import React from 'react';
import { Resource, ResourceInfo, ResourceProps } from 'omni-package-react-core';
import { useSitecoreJssQuery } from 'omni-package-react-cms';
import transformData from './transformData';
import { CrossSellingDto } from '../../../../interfaces/Dto/CrossSellingDto';

export const CrossSellingResourceInfo: ResourceInfo = {
  name: '/App.features.products.crossSellingResource',
  dataDst: '/App.features.products.crossSellingData',
};

const CrossSellingResource = <Data, Error = {}>({ ...props }: ResourceProps<Data, Error>) => {
  const url = useSitecoreJssQuery('bannersIAAH');
  return (
    <Resource
      url={url}
      {...CrossSellingResourceInfo}
      {...props}
      transformResponse={(crossSellingDto: CrossSellingDto) => transformData(crossSellingDto)}
    />
  );
};
export default CrossSellingResource;
